// extracted by mini-css-extract-plugin
export default {"card":"TY-z","carouselContainer":"UY-z","carouselContent":"VY-z"};